module.exports = __webpack_public_path__ + "static/img/投影交互游戏开发.771a4b80.png";